
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket/venues/[...slug]",
      function () {
        return require("private-next-pages/cricket/venues/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket/venues/[...slug]"])
      });
    }
  